<div class="content-container">

  <div class="cf">

    <div class="section courses-filter">
        <div>
          <h1 class="heading">{{locale.titleText}}</h1>
          <p class="normal">{{locale.subtitleText}}</p>
          <p class="normal">
            <a *ngIf="courseCourseFilter.options" (click)="setSelected(false)" class="underline">{{locale.clearFilterButtonText}}</a>
          </p>
        </div>
    </div>

    <div class="section courses-filter-results">
      <div class="course-list" *ngFor="let area of courseCourseFilter.options">
        <div class="course-list-header">
          <h2 class="heading">{{area.values[0].value}}</h2>
          <div class="select-all" *ngIf="courseCourseFilter.options">
            <app-tick-button [selected]="areaHasAllCoursesSelected(area)" (click)="setSelectedAreaOptions(area, !areaHasAllCoursesSelected(area))">{{locale.selectAllFilterButtonText}}</app-tick-button>
            <p *ngIf="!areaHasAllCoursesSelected(area)" class="normal title" (click)="setSelectedAreaOptions(area,true)">{{locale.selectAllFilterButtonText}}</p>
            <p *ngIf="areaHasAllCoursesSelected(area)" class="normal title" (click)="setSelectedAreaOptions(area,false)">{{locale.deSelectAllFilterButtonText}}</p>
          </div>
        </div>
        <div *ngFor="let course of area.options" class="course">
          <app-tick-button [selected]="course.selected" (click)="selectCourse(course)">Select course</app-tick-button>
          <p class="normal title" (click)="selectCourse(course)">{{course.values[0].value}}</p>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/course-areas/filters/course-area-courses-filter/course-area-courses-filter.component.html